<template>
  <common-modal
    :name="name"
    :title="title"
    :hideFooter="true"
    height="320px"
    width="800px"
  >
    <template #modal-body>
      <validation-form @on-submit="addActivity">
        <md-card class="my-0">
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-50">
                <validation-field
                  :validations="classValidation.name"
                  name="name"
                >
                  <label>{{ $t("class.extra_coursework_activity") }}</label>
                  <md-input v-model.trim="form.name" required></md-input>
                  <span
                    style="top:30px"
                    class="md-error"
                    v-if="serverValidations.name"
                    >{{ serverValidations.name }}</span
                  >
                </validation-field>
              </div>
              <div class="md-layout-item md-size-50">
                <md-field>
                  <label :for="select.name">{{ $t(select.label) }} </label>
                  <md-select
                    required
                    v-model="form.classActivityCategoryId"
                    :name="select.name"
                    :id="select.name"
                    :multiple="select.multiple"
                  >
                    <md-option
                      v-for="option in select.options"
                      :value="option.id"
                      :key="option.id + option.name"
                      >{{ option.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50">
                <validation-field
                  :validations="classValidation.maxPoint"
                  name="max point"
                >
                  <label> {{ $t("class.max_point") }}</label>
                  <md-input v-model="form.maxPoint" required></md-input>
                  <span
                    style="top:30px"
                    class="md-error"
                    v-if="serverValidations.name"
                    >{{ serverValidations.max_point }}</span
                  >
                </validation-field>
              </div>
            </div>
          </md-card-content>
        </md-card>
        <div class="form-actions text-right pt-3 pb-3">
          <md-button class="md-raised" @click="closeModal">{{
            $t("common.cancel")
          }}</md-button>
          <md-button type="submit" class="md-success ml-4">{{
            $t("common.add_new")
          }}</md-button>
        </div>
      </validation-form>
    </template>
  </common-modal>
</template>

<script>
import CommonModal from "@/components/Base/CommonModal";
import { parameterValidations } from "@/validations/classes";
import { service_names, service_paths } from "@/constants/Services";
import { genErrMsgOj, Message, convertObj } from "@/helpers/utils";
export default {
  components: { CommonModal },
  props: ["name", "title"],
  inject: ["getScores"],
  data() {
    const classId = this.$route.params.id;
    return {
      pathGetCategories: `${service_paths.class_activity_categories}/class/${classId}`,
      path: `${service_names.school}/activity-class-lms`,
      pathGetStudent: `${service_names.school}/classes/${classId}/students`,
      form: {
        name: "",
        classActivityCategoryId: null,
        maxPoint: null,
        classId: classId
      },
      serverValidations: {},
      classValidation: parameterValidations,
      select: {
        label: "class.category",
        name: "status__",
        value: "",
        type: "select",
        options: []
      },
      hasStudentInClass: false
    };
  },
  watch: {
    "form.name": function() {
      this.serverValidations.name && delete this.serverValidations.name;
    },
    "form.max_point": function() {
      this.serverValidations.max_point &&
        delete this.serverValidations.max_point;
    }
  },
  methods: {
    initData() {
      this.resetForm();
      this.getParameters();
      this.getStudentOfClass();
    },
    resetForm() {
      this.form = Object.assign(this.form, {
        name: "",
        classActivityCategoryId: this.form.classActivityCategoryId,
        maxPoint: null
      });
    },
    closeModal() {
      this.$modal.hide(this.name);
    },
    addActivity() {
      if (!this.hasStudentInClass) {
        Message.error(this.$t("class.there_are_no_students_in_this_class"));
        return;
      }
      const form = convertObj.camelCaseToSnakeCase(this.form);
      this.$axios
        .post(this.path, form)
        .then(async () => {
          Message.success(this.$t("common.add_success"));
          this.getScores();
          this.closeModal();
        })
        .catch(error => {
          const errData = error.response?.data;
          if (errData) {
            const svErrMsgs = errData.messages;
            this.serverValidations = genErrMsgOj(svErrMsgs);
          }
        });
    },
    getParameters() {
      return this.$axios
        .get(
          this.pathGetCategories,
          { undefined },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          if (response.data) {
            this.select.options = response.data
              .filter(item => !item.is_default)
              .map(item => {
                return { name: item.name, id: item.id };
              });
            this.form.classActivityCategoryId = this.select.options[0]?.id;
          }
        });
    },
    getStudentOfClass() {
      this.$axios
        .get(
          this.pathGetStudent,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          this.hasStudentInClass = response.data.data.length > 0;
        });
    }
  }
};
</script>

<style lang="scss"></style>
